import { useEffect } from 'react';
import { Image } from 'react-native';
import FastImage from 'react-native-fast-image';

type UsePrefetchImagesOptions = {
    urls?: string[];
    enabled?: boolean;
};

export function usePrefetchImages(options: UsePrefetchImagesOptions) {
    useEffect(() => {
        const { enabled = true, urls } = options;
        if (enabled && urls && urls?.length > 0) {
            FastImage.preload(
                urls.filter((item) => !!item).map((url) => ({ uri: url })),
            );
            Promise.allSettled(
                urls.filter((item) => !!item).map((url) => Image.prefetch(url)),
            );
        }
    }, [options]);
}
